export default function initializeSearch() {
    initializeSearchBox();
}

function initializeSearchBox() {
    let button = document.querySelector('.search-button-container__image-container');

    if (button) {
        document.querySelector('#search-button').addEventListener('click', searchClick);
    }

    if (document.body.classList.contains('search')) {
        document.querySelector('#search-form').classList.add('search-form--active');
    }
}

function searchClick(e) {
    let parent = document.querySelector('#search-form'),
        searchInput = parent.querySelector('input[type="text"]');

    if (!parent.classList.contains('search-form--active') || searchInput.value.length <= 0) {
        e.preventDefault();
        parent.classList.toggle('search-form--active');

        if (parent.classList.contains('search-form--active')) {
            let len = searchInput.value.length * 2;

            searchInput.focus();
            searchInput.setSelectionRange(len, len);
        } else {
            parent.focus();
        }
    }
}